import { ToggleButton, ToggleButtonGroup } from "react-bootstrap";
import { SCALE } from "@ld-scorecard/shared";

const VARIANTS: Record<number, string> = {
  1: "outline-danger",
  2: "outline-warning",
  3: "outline-secondary",
  4: "outline-primary",
  5: "outline-success",
};

/** 1–5 score picker. `null`/undefined means "not scored". */
export default function ScoreSelector({
  value,
  onChange,
  name,
  disabled,
}: {
  value?: number;
  onChange: (v: number) => void;
  name: string;
  disabled?: boolean;
}) {
  return (
    <ToggleButtonGroup
      type="radio"
      name={name}
      value={value ?? 0}
      onChange={(v: number) => onChange(v)}
    >
      {SCALE.map((s) => (
        <ToggleButton
          key={s.value}
          id={`${name}-${s.value}`}
          value={s.value}
          variant={value === s.value ? VARIANTS[s.value].replace("outline-", "") : VARIANTS[s.value]}
          size="sm"
          disabled={disabled}
          title={s.label}
          className="score-pill"
        >
          {s.value}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
}
